module.exports = __webpack_public_path__ + "static/media/shelter_fishing_marker.b5009bd9.svg";